import CAJA1080RequestModel from '@/api/data/CAJ/CAJA1080/CAJA1080RequestModel'
import CAJA1080ResponseModel from '@/api/data/CAJ/CAJA1080/CAJA1080ResponseModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1080Service {
  /**
   * レスポワール定期刊行物情報取得
   * @returns APIからのレスポンスデータ
   */
  public async callAPICAJA1080(): Promise<CAJA1080ResponseModel> {
    const caja1080RequestModel: CAJA1080RequestModel =
      new CAJA1080RequestModel()
    const caja1080ResponseModel: CAJA1080ResponseModel = <
      CAJA1080ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1080, caja1080RequestModel)
    return caja1080ResponseModel
  }
}
